import React, {forwardRef} from 'react';
import PropTypes from 'prop-types';

import {BasicInput as BaseBasicInput, Input as BaseInput} from '@spothero/ui';

const inputStyleProps = {
    fontSize: 'base',
    paddingX: 2,
    paddingY: 2,
};

/**
 * Input component that uses the fe-ui Input component
 * @type {ForwardRefExoticComponent<PropsWithoutRef<P> & RefAttributes<T>>}
 */
const Input = forwardRef(({includeFormControl, ...props}, ref) => {
    return includeFormControl ? (
        <BaseInput ref={ref} {...inputStyleProps} {...props} />
    ) : (
        <BaseBasicInput ref={ref} {...inputStyleProps} {...props} />
    );
});

Input.propTypes = {
    /** Whether the input rendered should be the basic or standard (wrapped in the FormControl component) Input component */
    includeFormControl: PropTypes.bool,
    /** The following props are applied to the standard fe-ui Input component (wrapped in the FormControl component) */
    /** The id of the Input. Used to associate the Label and the Input field */
    id: PropTypes.string.isRequired,
    /** The text for Label tag associated with the Input */
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    /** The helper text to show above the Input field  */
    helperText: PropTypes.string,
    /** The error message to show below the Input field */
    errorMessage: PropTypes.string,
    /** Whether to show the input field in the invalid state */
    isInvalid: PropTypes.bool,
    /** Whether to show the input field in the disabled state */
    isDisabled: PropTypes.bool,
    /** Whether the Input is required */
    isRequired: PropTypes.bool,
    /** Whether the Input is optional */
    isOptional: PropTypes.bool,
    /** A custom string to show when the Input is required */
    customRequiredText: PropTypes.string,
};

Input.defaultProps = {
    includeFormControl: true,
};

export default Input;
